import { useSyncExternalStore } from 'react';

/** Resolves the operator's `DemoReveal.primary` knob, `try_again` when unset (index.css). */
const DEMO_PRIMARY_SWITCH = '--ui-demo-primary';
const PULL_FOR_REAL = 'pull_for_real';

// The Design Constructor writes its knobs as inline styles on <html>; a
// preview toggle swaps the buttons without a reload.
function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  return () => observer.disconnect();
}

function isPullForRealPrimary(): boolean {
  return getComputedStyle(document.documentElement).getPropertyValue(DEMO_PRIMARY_SWITCH).trim() === PULL_FOR_REAL;
}

/** True when the operator made "Pull for Real" the demo result's main button in the Design Constructor. */
export function useDemoPullForRealPrimary(): boolean {
  return useSyncExternalStore(subscribe, isPullForRealPrimary, () => false);
}
